// src/sectors/pilates/sessions/components/SessionDetailDialog/sessionDetail.utils.js

export const clean = (x) => (x ?? '').toString().trim().replace(/\s+/g, ' ');
export const upper = (x) => (x ?? '').toString().trim().toUpperCase();

export function hm(min) {
  const m = Number(min) || 0;
  const hh = String(Math.floor(m / 60)).padStart(2, '0');
  const mm = String(m % 60).padStart(2, '0');
  return `${hh}:${mm}`;
}

export const TR = {
  billingMode: (v) => {
    const x = upper(v);
    if (x === 'PACKAGE') return 'Paket';
    if (x === 'PAID') return 'Ücretli';
    if (x === 'FREE') return 'Ücretsiz';
    return v ? v : '—';
  },
  sessionType: (v) => {
    const x = upper(v);
    if (x === 'TELAFI') return 'Telafi';
    if (x === 'NORMAL') return 'Normal';
    return v ? v : '—';
  },
  status: (v) => {
    const x = upper(v);
    if (x === 'APPROVED') return 'Onaylı';
    if (x === 'CANCELLED') return 'İptal';
    if (x === 'DRAFT') return 'Taslak';
    return v ? v : '—';
  },
  attendance: (v) => {
    const x = upper(v);
    if (x === 'PENDING') return 'Beklemede';
    if (x === 'ATTENDED') return 'Geldi';
    if (x === 'NO_SHOW') return 'Gelmedi';
    if (x === 'CANCELLED') return 'İptal';
    return v ? v : 'Yok';
  },
  noteType: (v) => (upper(v) === 'REMINDER' ? 'Hatırlatma' : 'Not'),
  channel: (v) => {
    const x = upper(v);
    if (x === 'IN_APP') return 'Uygulama içi';
    if (x === 'EMAIL') return 'E-posta';
    return v || '—';
  },
};

export const pickActivity = (s) =>
  s?.activityName || s?.activityNameSnapshot || s?.title || 'Seans';
export const pickTrainer = (s) => s?.trainerNameSnapshot || s?.trainerName || '—';

export const pickParticipants = (s) => {
  const raw = Array.isArray(s?.participants)
    ? s.participants
    : Array.isArray(s?.participants?.items)
    ? s.participants.items
    : Array.isArray(s?.attendees)
    ? s.attendees
    : Array.isArray(s?.members)
    ? s.members.map((m) => ({ fullName: m }))
    : [];

  return raw
    .map((p, idx) => {
      const name =
        p?.fullName ||
        p?.memberNameSnapshot ||
        p?.memberName ||
        p?.memberFullName ||
        p?.attendeeName ||
        (p?.member
          ? p.member.fullName || `${p.member.name ?? ''} ${p.member.surname ?? ''}`.trim()
          : '') ||
        '—';

      return {
        id: p?.id ?? p?.memberId ?? `${idx}`,
        memberId: p?.memberId ?? null,
        fullName: name,
        phone: p?.phone ?? null,
        attendanceStatus: p?.attendanceStatus ?? null,
        billingMode: p?.billingMode ?? null,
        priceTry: p?.priceTry ?? null,
        debtTry: p?.debtTry ?? null,
        memberPackageId: p?.memberPackageId ?? null,
        packagePlanName: p?.packagePlanName ?? null,
        packageStartAt: p?.packageStartAt ?? null,
        packageEstimatedEndAt: p?.packageEstimatedEndAt ?? null,
        attNote: p?.attNote ?? null,
      };
    })
    .filter(Boolean);
};

export function statusMeta(st) {
  const x = upper(st);
  if (x === 'ATTENDED') return { tone: 'mint', icon: 'check_circle', label: 'Geldi' };
  if (x === 'NO_SHOW') return { tone: 'red', icon: 'cancel', label: 'Gelmedi' };
  if (x === 'CANCELLED') return { tone: 'blue', icon: 'event_busy', label: 'İptal' };
  return { tone: 'blue', icon: 'schedule', label: 'Beklemede' };
}
